import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import type { StartScanRequest } from '../types/scanner';

export function useScan() {
  return useMutation({
    mutationFn: (request: StartScanRequest) => api.startScan(request),
  });
}

export function useFileScan() {
  return useMutation({
    mutationFn: ({ file, region, industry }: { file: File; region: string; industry: string }) =>
      api.startFileScan(file, region, industry),
  });
}

export function useScanStatus(scanId: string | null, enabled = true) {
  return useQuery({
    queryKey: ['scan', scanId],
    queryFn: () => api.getScanStatus(scanId!),
    enabled: enabled && !!scanId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === 'completed' || status === 'failed') {
        return false;
      }
      return 2000;
    },
  });
}
